import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { PreviewUnavailablePage } from "@/pages/PreviewPage";
import {
  CURRENT_APP_ENVIRONMENT,
  isRouteAvailableInEnvironment,
} from "@/config/preview";

export const AppLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const routeAvailable = isRouteAvailableInEnvironment(
    pathname,
    CURRENT_APP_ENVIRONMENT,
  );

  return (
    <div className="min-h-screen bg-background">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="lg:pl-64">
        <Header onOpenSidebar={() => setMobileOpen(true)} />
        <main
          data-testid="main-content"
          key={pathname}
          className="animate-rise px-4 py-6 lg:px-8 lg:py-8"
        >
          {routeAvailable ? <Outlet /> : <PreviewUnavailablePage />}
        </main>
      </div>
    </div>
  );
};
